import { action } from '@ember/object';
import CheckoutBase from './base';

export default class SiteBillingPaymentInstrumentPaymentModalCheckoutInstrumentSection extends CheckoutBase {
  selectedInstrument(instrumentType) {
    return this.paymentModel.stripePaymentInstrumentType === instrumentType
      ? this.paymentModel.stripePaymentInstrument
      : null;
  }

  @action
  selectInstrument(instrument) {
    this.paymentInstrumentModals.setPaymentInstrument(this.paymentModel, instrument);
  }
}
